// extracted by mini-css-extract-plugin
module.exports = {"block":"block--1kvYS","divider":"divider--ZWwTQ","button":"button--1sh6I"};
    if(module.hot) {
      // 1732531529249
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  